const header = ['id', 'produto', 'principio_ativo', 'apresentacao', 'dosagem', 'laboratorio', 'qtd_embalagem', 'preco', 'preco_pbm', 'pmc_18', 'liquido', 'fora_da_box'];

export default header;
